export default __webpack_public_path__ + "static/media/MGH.814777b0.svg";